import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const colorToClassNameMap = {
  success: 'cuiCtaGem--success',
  highlight: 'cuiCtaGem--highlight',
};

export const CuiCtaGem = ({ className, classNameArt, color, ...rest }) => {
  const classes = classNames(
    'cuiCtaGem',
    className,
    colorToClassNameMap[color]
  );
  const classesArt = classNames('cuiCtaGem__art', classNameArt);

  return (
    <div className={classes} {...rest}>
      <div className="cuiCtaGem__bg" />
      <div className={classesArt} />
    </div>
  );
};

CuiCtaGem.propTypes = {
  className: PropTypes.string,
  classNameArt: PropTypes.string,
  color: PropTypes.string,
};

CuiCtaGem.defaultProps = {
  className: undefined,
  classNameArt: undefined,
  color: 'success',
};



// WEBPACK FOOTER //
// ./ui/components/ctaGem/CtaGem.js